module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-4@3x.ver2_0_2.jpg?386aee55";